import axios from 'axios';
import Vue from 'vue'



export default {
    get (menuCode, latitude, longitude, tableNumber, ts, did) {
        return axios.get('/api/orders/processing/get', { params: {menuCode: menuCode, tableNumber:tableNumber, ts:ts, latitude:latitude, longitude:longitude, did:did} })
        .then(response => {
            return response;
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    add (menuCode ,tableNumber, ts, lines, latitude, longitude, did) {
        return axios.post('/api/orders/processing/add', {menuCode: menuCode, tableNumber:tableNumber, ts:ts, lines: lines, latitude:latitude, longitude:longitude, did:did})
        .then(response => {
            return response;
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    remove (menuCode, tableNumber, ts, orderLineId, did) {
        return axios.post('/api/orders/processing/remove', {menuCode: menuCode, tableNumber:tableNumber, ts:ts, orderLineId:orderLineId, did:did})
        .then(response => {
            return response;
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    callWaiter (callWaiterReason) {
        const url = new URL(window.location.href);
        const pathSegments = url.pathname.split('/');
        const menuCode = pathSegments[pathSegments.length - 1];
        const tid = url.searchParams.get('tid');
        const did = url.searchParams.get('did');
        const ts = url.searchParams.get('ts');

        return axios.post('/api/orders/processing/call-waiter', {menuCode: menuCode, tableNumber:tid, ts:ts, callWaiterReason: callWaiterReason, did:did})
        .then(response => {
            return response;
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    findCallWaiterReason ( lang) {
        const url = new URL(window.location.href);
        const pathSegments = url.pathname.split('/');
        const menuCode = pathSegments[pathSegments.length - 1];

        return axios.get('/api/orders/processing/call-waiter-reason', {params :  {codeMenu: menuCode, lang: lang} })
        .then(response => {
            if (response && response.data) return response.data
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

    addNote (orderLineId, note) {
        const url = new URL(window.location.href);
        const pathSegments = url.pathname.split('/');
        const menuCode = pathSegments[pathSegments.length - 1];
        const tid = url.searchParams.get('tid');
        const did = url.searchParams.get('did');
        const ts = url.searchParams.get('ts');

        return axios.post('/api/orders/processing/add-note', {menuCode: menuCode, tableNumber:tid, ts:ts, orderLineId: orderLineId, note:note, did:did})
        .then(response => {
            return response
        })
        .catch(error => {Vue.prototype.$snotify.error(error);})
    },

}
